(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.colors = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    // Primary
    prussian: '#2d344b',
    prussian300: '#dfe1e7',
    orange: '#f36e21',
    peach: '#faa918',
    jungle: '#3a833c',
    tomato: '#e06c4f',
    brown: '#92613a',
    // Secondary
    gold: '#f7ce6a',
    blonde: '#fffae5',
    leaf: '#61c16c',
    mint: '#e6f4e9',
    mint600: '#c5e8c9',
    // Neutral
    slate: '#707070',
    stone: '#b5b5b5',
    silver: '#d9d9d9',
    mercury: '#e6e6e6',
    platinum: '#f5f5f5',
    white: '#ffffff',
    // Special
    soil: '#814026',
    dragon: '#ac0b1f',
    rose: '#ffebe5',
    lightPrussian: '#f0f2f6'
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/styles/colors.js
// module id = 50
// module chunks = 1